import { render, staticRenderFns } from "./ImageVertical.vue?vue&type=template&id=1a99df5f&scoped=true&lang=pug&"
import script from "./ImageVertical.vue?vue&type=script&lang=ts&"
export * from "./ImageVertical.vue?vue&type=script&lang=ts&"
import style0 from "./ImageVertical.vue?vue&type=style&index=0&id=1a99df5f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99df5f",
  null
  
)

export default component.exports